import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges, ViewChild } from "@angular/core";
import { VDateSelectorComponent } from "@app/directives/_veri/v-date-selector/v-date-selector.component";
import { TimeFilterType } from "@app/main/components/reports/enums/TimeFilterType";
import { TranslationService } from "@app/services/translation.service";
import { VButtonDropdownComponent } from "@directives/_core/v-dropdown/v-button-dropdown/v-button-dropdown.component";
import { DateRange } from "@enums/DateRange.enum";
import { DateService } from "@services/date.service";
import { VeriDate } from "@services/veriDate.service";
import { FilterBarComponent } from "../filter-bar.component";
import { FilterTriggerType, IFilterBarFilter } from "../filter-bar.models";
import "./date-button-filter.component.scss";

@Component({
    selector: "date-button-filter",
    template: require("./date-button-filter.component.html")
})
export class DateButtonFilterComponent implements IFilterBarFilter<Date[]>, OnInit, OnChanges {

    @Input() date: Date; // Single date will override startDate and endDate

    @Input() startDate: Date;
    @Input() endDate: Date;
    @Input() dateRange: DateRange;

    @Input() maxDays = 31;

    @Input() label: string;

    @Input() showTimeFilter: boolean;
    @Input() timeIncrements: number;
    @Input() showDailyFilter: boolean;

    @Input() hideFilter: boolean;

    @Output() change = new EventEmitter<Date[]>();
    @Output() datetimeChange = new EventEmitter<{ startDate: Date, endDate: Date, startTime: string, endTime: string, timeFilterType: TimeFilterType }>();

    @ViewChild(VButtonDropdownComponent) dropdown: VButtonDropdownComponent;
    @ViewChild(VDateSelectorComponent) dateSelector: VDateSelectorComponent;

    // ---

    selected: any; // for interface
    name = "Date Range";
    icon = "today";
    type: FilterTriggerType = "date";

    errorMessage: string;

    startTime: string;
    endTime: string;

    timeFilterType: TimeFilterType = TimeFilterType.None;

    private defaultLabel = "No Date Filter";

    constructor(
        @Optional() private parent: FilterBarComponent,
        readonly elementRef: ElementRef<HTMLElement>,
        private readonly veriDate: VeriDate,
        private readonly dateService: DateService,
        private readonly translationService: TranslationService) {
        this.label = this.defaultLabel;
    }

    ngOnInit(): void {
        // Default to today
        if (!this.startDate) {
            this.startDate = this.dateService.getStartOfDay(new Date());
            this.endDate = new Date();

            this.updateLabelText();
        }

        if (this.startDate && this.showTimeFilter) {
            this.setTimes();
        }
    }

    ngAfterViewInit(): void {
        if (!this.parent) {
            return;
        }

        this.hideFilter && this.parent.registerFilter(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.date) {
            this.startDate = this.date;
            this.endDate = this.date;
        }

        if (changes["dateRange"]) {
            this.createDatesFromDateRange();
        }

        if (changes["date"] || changes["startDate"] || changes["endDate"] || changes["dateRange"]) {
            this.emitChange();
            this.updateLabelText();
            this.setTimes();
        }
    }

    onDateRangeChanged(dates: Date[]): void {
        this.startDate = dates[0];
        this.endDate = dates[1];
    }

    onApply(): void {
        if (this.showTimeFilter) {
            this.applyRangeStartAndEnd();
        }

        this.emitChange();
        this.updateLabelText();

        this.onClose();
    }

    onClose(): void {
        this.dropdown.closeDropdown();
    }

    // ---

    private emitChange(): void {
        if (this.showTimeFilter) {
            var changeObject = { startDate: this.startDate, endDate: this.endDate, startTime: this.startTime, endTime: this.endTime, timeFilterType: this.timeFilterType };
            this.datetimeChange.emit(changeObject);
            this.parent?.onFilterChange("datetime", changeObject);
        }
        var event = [this.startDate, this.endDate];
        this.change.emit(event);
        this.parent?.onFilterChange("date", event);
    }

    private setTimes(): void {
        this.startTime = this.dateService.getTimeAsString(this.startDate);
        this.endTime = this.dateService.getTimeAsString(this.endDate);
    }

    private applyRangeStartAndEnd(): void {
        if (!this.startTime) {
            this.startDate = this.dateService.getStartOfDay(this.startDate);
            this.endDate = this.dateService.getEndOfDay(this.endDate);

            return;
        }

        this.startDate = this.dateService.updateTime(this.startDate, this.startTime);
        this.endDate = this.dateService.updateTime(this.endDate, this.endTime);
    }

    private updateLabelText(): void {
        if (!this.startDate || !this.endDate) {
            return;
        }

        this.label = this.dateService.formatDateRange(this.startDate, this.endDate);
    }

    private createDatesFromDateRange(): void {

        var startEnd = this.veriDate.dateRangeFromEnum(this.dateRange);

        this.startDate = startEnd.start;
        this.endDate = startEnd.end;
    }
}
